export default function reducer(state={
  video: null
}, action) {

  if(action.type === "WATCH_VIDEO") {
    return {
      ...state, video: action.payload
    }
  } else if (action.type === "CLOSE_VIDEO") {
    return {
      ...state, video: null
    }
  } else {
    return state
  }

}